var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "file",
    width: 27.067,
    height: 27.173,
    viewBox: "0 0 27.067 27.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M8.165,242a7.165,7.165,0,1,0,7.165,7.165A7.173,7.173,0,0,0,8.165,242Zm3.163,6.295L7.613,252.01a.8.8,0,0,1-1.126,0L4.9,250.418a.8.8,0,0,1,1.126-1.126l1.029,1.029,3.152-3.152a.8.8,0,1,1,1.126,1.126Z",
    transform: "translate(-1 -229.157)",
    fill: "#4e3057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M135.595,6.9a.8.8,0,0,1-.8-.8V0H123.388A2.391,2.391,0,0,0,121,2.388v8.9c.262-.024.528-.037.8-.037a8.743,8.743,0,0,1,6.75,3.184h8.641a.8.8,0,0,1,0,1.592h-7.592a8.69,8.69,0,0,1,.921,3.184h6.671a.8.8,0,0,1,0,1.592h-6.671a8.76,8.76,0,0,1-3.691,6.369H139.31a2.391,2.391,0,0,0,2.388-2.388V6.9Zm1.592,4.352H125.511a.8.8,0,1,1,0-1.592h11.676a.8.8,0,0,1,0,1.592Z",
    transform: "translate(-114.631)",
    fill: "#4e3057"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M411,8.783v4.841h4.841Z",
    transform: "translate(-389.24 -8.317)",
    fill: "#4e3057"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.00bc733df4c0bb2d785a3d1808f6d9a7.svg";
export { ForwardRef as ReactComponent };